import { createAsyncActions } from '@wahaaabello/redux-async-actions';

const [
  fetchFormRequest,
  fetchFormSuccess,
  fetchFormFailure
] = createAsyncActions('FETCH_FORM');

const formsActions = {
  fetchFormRequest,
  fetchFormSuccess,
  fetchFormFailure
};

export default formsActions;
